/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from 'react';

export interface ActionMenuAccordionContextProps {
  openId: string;
  setOpenId: (openId: string) => void;
}

export const ActionMenuAccordionContext =
  createContext<ActionMenuAccordionContextProps>({
    openId: '',
    setOpenId: () => {},
  });

export interface ActionMenuAccordionItemContextProps {
  id: string;
  isDisabled: boolean;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}
export const ActionMenuAccordionItemContext =
  createContext<ActionMenuAccordionItemContextProps>({
    id: '',
    isDisabled: false,
    isOpen: false,
    setIsOpen: () => {},
  });
